import React, { useRef, useState, useEffect, use } from 'react';
//import ReCAPTCHA from "react-google-recaptcha";
import Layout from '../templates/Layout';
import TabbedLayout from '../organisms/TabbedLayout';
import SettingsTable from '../organisms/SettingsTable';
import WaitingComponent from '../organisms/Waiting';
import ErrorComp from '../organisms/Tomeout';
import ErrorComponent from '../organisms/ErrorComponent';
import '../../styles/reset.css';
import '../../styles/Styles.css';
import warning from '../../images/warning.png';

function HomePage () {
    //const recaptchaRef = useRef(null);
    const [activeTab, setActiveTab] = useState('Screen1');
    const [domain, setDomain] = useState('');
    const [initialDomainSet, setInitialDomainSet] = useState(false);
    const [settings, setSettings] = useState([]);
    //const [imageSrc, setImage] = useState();
    const [error, setError] = useState('');
    //const [ipAddress, setIpAddress] = useState('');
    const [buttonEnabled, setButtonEnabled] = useState(true);
    //const [polling, setPolling] = useState();
    const [status, setStatus] = useState(null);
    const inputRef = useRef(null);
    const [click, setClick] = useState(0);
    const [cmessage, setcmessage] = useState('');
    //const intervalRef = useRef(null);

    useEffect(() => {
      //console.log('checkpoint 1');
        const checkCaptchaStatus = async () => {
          
          //console.log('checkpoint 2');
          if (click >= 0  && click <= 6) {
            //console.log('checkpoint 3');
            //console.log('click value: ', click);
            //console.log('captcha value: ', status);
            //console.log('Before send fetch request');
                try {
                  //console.log('checkpoint 4');
                    //http://localhost:80/emailsettings/Domain-Scan-Email-Settings/backend/controllers/checkRecaptcha.php
                    ///domainscan/controllers/checkRecaptcha.php
                    const response = await fetch('/domainscan/controllers/checkRecaptcha.php', {
                        credentials: 'include',
                    });
                    //.log('checkpoint 5');
                    //console.log('server response status123: ', response);
                    
        
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    //console.log('checkpoint 6');
                    const data = await response.json();
                    //console.log("Received Data from fetch request:", data);
                    //console.log('server response message', data.message);
                    //console.log('checkpoint 7');
                    if (data.cstatus === 'pass') {
                      //console.log('checkpoint 8');
                        setStatus('cpass')
                        setcmessage(data.message);
                        //setError('');
                        //setButtonEnabled(true); // Enable button if CAPTCHA is successful
                        //console.log('Passed');
                    } else if (data.cstatus === 'fail') {
                      //console.log('checkpoint 9');
                        setStatus('cfail');
                        setcmessage(data.message);
                        //setButtonEnabled(false);
                        //console.log('Verification Failed');
                        //console.log('waiting for google response');
                        //setError('reCAPTCHA verification failed');
                    } else if (data.cstatus === 'notset') {
                      //console.log('checkpoint 10');
                      //const whError = data.werror;
                      setStatus('cnotset');
                      setcmessage(data.message);
                      setTimeout(() => setClick(click => click + 1), 1000);
                      //setWhileError(whError);
                    } else {
                      //console.log('checkpoint 11');
                      setStatus('cerror');
                      setcmessage(data.message);
                    }
                    //console.log('checkpoint 12');
                } catch (error) {
                    console.error('Error checking captcha status:', error);
                }
                //console.log('checkpoint 13');
              }
              //console.log('checkpoint 14');
            };
            //console.log('checkpoint 15');
        checkCaptchaStatus();
    }, [click]);

    useEffect(() => {
        console.log("Window location search:", window.location.search);
            const params = new URLSearchParams(window.location.search);
            const domainParam = params.get('domain');
            console.log('domain passed by url:', domainParam);
    
            if (domainParam && !initialDomainSet) {
                
                setDomain(domainParam);
                inputRef.current?.classList.add('highlighted');
                setTimeout(() => inputRef.current?.classList.remove('highlighted'), 3000);
                setInitialDomainSet(true); // Mark the URL parameter as processed
                
                /*console.log('domain before handle submit in useeffect:', domain);
                if (domainParam === domain) {
                    handleSubmit({preventDefault: () => {} });
                }*/
            }
        }, [initialDomainSet]);
    
    useEffect(() => {
            const params = new URLSearchParams(window.location.search);
            const domainParam = params.get('domain');
            console.log('URL in address bar', domainParam);
        
            if (domain && domainParam === domain) {
                handleSubmit({ preventDefault: () => {} });
            }
    }, [domain]);
        
    
    /*useEffect(() => {
            inputRef.current?.focus();
    }, []);*/
    
    useEffect(() => {
            const handleKeyDown = (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    setButtonEnabled(true);
                    handleSubmit(e);
                }

                setTimeout(() => {
                    setButtonEnabled(true);
                }, 3000);
                
            };
    
            document.addEventListener('keydown', handleKeyDown);
            return () => document.removeEventListener('keydown', handleKeyDown);
    }, [domain]);

    const getSettingsFromXML = async (serverName) => {
      try {
          //domainscan/controllers/serve_xml.php?serverName=` + serverName
          //http://localhost:80/emailsettings/Domain-Scan-Email-Settings/backend/controllers/serve_xml.php
          const response = await fetch(`/domainscan/controllers/serve_xml.php?serverName=` + serverName);
          //console.log('get settings response', response);
          if (!response.ok) {
              throw new Error("Failed to fetch filtered XML data");
          }
          console.log('before fetching data');
          const data = await response.json();
          //console.log("XML Data", data);

          if (data.success) {
              return data.serverDetails;
              //console.log('set data'); // Set serverDetails directly as table data
          } else {
              console.error('Server not found:', data.message);
              //console.log('Not set');
              setError(data.message);
              return null;
          }
      } catch (error) {
          console.error('Error fetching or parsing XML:', error);
          setError('Failed to load settings.');
          return null;
      }
    };

    const extractAndValidateDomain = (input) => {
      //input = "sinnb.com";
      const sanitizedInput = input.trim();
      //console.log("Sanitized Input: ", sanitizedInput);

      //handle email adsress
      if (sanitizedInput.includes('@')) {
          const emailParts = sanitizedInput.split('@');
          //console.log("Email parts: ", emailParts);
          if (emailParts.length === 2 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(sanitizedInput)) {
              return emailParts[1];
          } else {
              return "Invalid domain: Malformed Email Address.";
          }
      }

     //handle urls
     try {
      const url = new URL(sanitizedInput.includes("://") ? sanitizedInput : `http://${sanitizedInput}`);
      //console.log("sanitized input url: ", url.hostname);

      const hostName = url.hostname;

      if (hostName.startsWith('-') || hostName.endsWith('-')) {
          //console.log("Invalid domain: Domain cannot start or end with a hyphen");
          return "Invalid domain: Domain cannot start or end with a hyphen.";
      }

      if (hostName.includes('--')) {
          //console.log("Invalid domain: Domain cannot contain consecutive hyphens");
          return "Invalid domain: Domain cannot contain consecutive hyphens.";
      }

      if (hostName.includes('..')) {
          //console.log("Invalid domain: Domain cannot contain consecutive dots");
          return "Invalid domain: Domain cannot contain consecutive dots.";
      }

      if (hostName.endsWith('.')) {
          //console.log("Invalid domain: Domain cannot end with a dot");
          return "Invalid domain: Domain cannot end with a dot.";
      }

      if (!hostName.includes('.')) {
          //console.log("Invalid domain: Domain must contain a dot");
          return "Invalid domain: Domain must contain a dot.";
      }

      return hostName;

     } catch (error) {
      console.log("Invalid url");
     }

      //validate plain domain format
      const domainRegex = /^(?!-)([A-Za-z0-9-]{1,63})(\.[A-Za-z]{2,})$/;
      //const domainRegex = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)\.[A-Za-z]{2,}$/;

      if (domainRegex.test(sanitizedInput)) {
          //console.log("sanitized input: ", sanitizedInput);
          return sanitizedInput;
      }

      // Handle other common domain forms and subdomains
      const subdomainRegex = /^[a-z0-9-]+\.[a-z]{2,}$/;
      if (subdomainRegex.test(sanitizedInput)) {
          //console.log("Valid subdomain input: ", sanitizedInput);
          return sanitizedInput;  // Return subdomain as valid domain
      }
      //handle cases for IP addresses
      const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;
      if (ipRegex.test(sanitizedInput)) {
          //console.log("Invalid domain: IP addresses are not valid domain names.");
          return "Invalid domain: IP addresses are not valid domain names.";
      }

      return "Invalid domain: Input does not match any valid domain format.";

    };

    const handleSubmit = async (e) => {
            e.preventDefault();  
            const domainResult = extractAndValidateDomain(domain);
            //console.log("domain result: ", domainResult);
    
            if (domainResult.startsWith("Invalid")) {
                //console.log("if condition passes true");
                setError(domainResult);
                setSettings([]);
                return;
            }
    
            setError('');
            setSettings([]);
            setButtonEnabled(false);
            setTimeout(() => {
                setButtonEnabled(true); // Re-enable the button
              }, 3000);
            //console.log('check button enable in submit function:', buttonEnabled);
    
          try {
            //.log('domain result ready to submit: ', domainResult);
            
            //index.php
            //http://localhost:80/emailsettings/Domain-Scan-Email-Settings/backend/public/api/lookup
              const response = await fetch('index.php',
                  {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', },
                      body: JSON.stringify({ action: 'lookup', domainResult}),
                      //body: JSON.stringify({ name: 'shey'}),
                  });
      
                //console.log("calling URL:", response);
                //console.log("Domain submitted:", domainResult);
      
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error('Failed to fetch data from the server.');
                }
      
                //console.log("before fetching data");
                const data = await response.json();
                //console.log("API response data", data);
                //console.log("API response data success", data.success);
    
                if (data?.success) {
                    //console.log('Data success');
    
                    /*const serverName = data.serverName;
                    console.log("server name: ", serverName); // Log API response
                    //setSettings(data.data?.data || []); // Assuming `data.data` is an array
                    //setImage(imgSrc);
    
                    const settingss = await getSettingsFromXML(serverName);
                    console.log('get settings function worked', settingss);
    
                    if (settingss && settingss.length > 0) {
                        setSettings(settingss);
                    } else {
                        setError('No settings found for the provided server name.');
                        setSettings([]);
                    }*/
    
                    if (data.serverName) {
                        const serverName = data.serverName;
                        //console.log("Server name found:", serverName);
                        const settingss = await getSettingsFromXML(serverName);
                        //console.log('get settings function worked', settingss);
    
                        if (settingss && settingss.length > 0) {
                            setSettings(settingss);
                        } else {
                            setError('No settings found for the provided server name.');
                            setSettings([]);
                        }
                    } else if (data.providerName) {
                        //console.log("Provider name found: ", data.providerName);
    
                        setSettings([]);
                        setError(
                            <>
                                Your domain is hosted with <span className='provider-name'>{data.providerName}</span>. <br /> Please contact your hosting provider for assistance with your email settings.
                            </>
                            
                        );
                    } else {
                        setError('No settings found for the provided server name.');
                        setSettings([]);
                    }
    
              } else {
                console.error("Error fetching settings:", data.message);
                setError(
                  <>
                    <div className='warning-icon' style={{display:'flex',flexDirection:'column',width: '100%',height: 'auto', gap: '10px', alignitems: 'center', justifyContent:'center', alignItems:'center'}}>
                        <img src={warning} alt='warning-icon' className='error-icon' style={{width:'40px'}}></img>
                        <span>{data.message}</span>
                    </div>
                            
                    </>
                        
                );
                setSettings([]);
              }
    
            } catch (error) {
                  console.error('Error while submitting domain:', error);
                  setSettings([]);
                  setError('There was an error processing your request.');
            }
    
            /*setTimeout(() => {
                setButtonEnabled(false);
            }, 3000);*/
    
            const params = new URLSearchParams(window.location.search);
            params.set('domain', domain); // Set the new domain in the URL
            window.history.pushState({}, '', `?${params.toString()}`);

            console.log("button status:", buttonEnabled);
            
    };






    /*const clickMe = (e) => {
      e.preventDefault();
      console.log('click count before btn click', click);
      //setClick((click) => click + 1);
      console.log('click count after btn click', click);
    }*/


    /*if (status === 'cpass') {
      return (
        <Layout>
            <ReCAPTCHA ref={recaptchaRef} sitekey='6Lc6iaQqAAAAAATtaDne2BuHD0xjKl7yWacM1O9_' size='invisible' />
            <TabbedLayout activeTab={activeTab} setActiveTab={setActiveTab} domain={domain} setDomain={setDomain} error={error} setError={setError} setSettings={setSettings} onClick={handleSubmit} setButtonEnabled={setButtonEnabled} inputRef={inputRef} />
            {domain && settings.length > 0 && (
                <SettingsTable settings={settings} />
            )}
       </Layout>
      )
    } else if (status === 'cfail') {
      return (
        <div className='additional-component'>
            <ErrorComponent />
        </div>
      )
    } else if (status === 'cnotset'){
      return(
        <div className='additional-component'>
            <WaitingComponent />
        </div>
      )
    } else if (status === 'cerror') {
      return(
        <Layout>
            <ErrorComp />
        </Layout>
      )
    }

    return (
      <div className='additional-component'>
          <WaitingComponent />
      </div>
      
    )*/

      return (
        <>

            <hr className="layout-hr-line" />

            {status === 'cpass' && 
                <Layout>
                    {/*<ReCAPTCHA ref={recaptchaRef} sitekey='6Lc6iaQqAAAAAATtaDne2BuHD0xjKl7yWacM1O9_' size='invisible' />*/}
                    <TabbedLayout activeTab={activeTab} setActiveTab={setActiveTab} domain={domain} setDomain={setDomain} error={error} setError={setError} setSettings={setSettings} onclick={handleSubmit} setButtonEnabled={buttonEnabled} inputRef={inputRef} />
                    {domain && settings.length > 0 && (
                        <SettingsTable settings={settings} />
                    )}
                </Layout>}
            {status === 'cfail' && 
                <ErrorComponent />}
            {status === 'cnotset' && 
                <WaitingComponent />}
            {status === 'cerror' && 
                <ErrorComp />}
            {!['cpass', 'cfail', 'cnotset', 'cerror'].includes(status) && 
                <WaitingComponent /> }
        </>
      )

};
export default HomePage;